module.exports = __webpack_public_path__ + "images/help-videos-preview-invite-1fd113a1f3540f96b033a3fbc5051bc1.png";